import { get as e } from "theme-ui";
const n = {
  maxWidth: "100%",
  "&:hover, &:active": {
    textDecoration: "none"
  }
}, i = {
  flexShrink: 0,
  mr: 1,
  color: "secondaryText",
  transition: (t) => `${e(t, "transitions.all")}, visibility 0ms`
}, r = {
  "&:hover, &:active": {
    textDecoration: "underline"
  }
}, a = {
  textDecoration: "underline"
}, c = {
  color: "secondaryText",
  transition: "all"
}, l = {
  color: "disabledText"
};
export {
  l as disabledIcon,
  c as icon,
  i as label,
  n as link,
  r as valueWrapper,
  a as valueWrapperActive
};
